<template>
  <div class="hover-menu__content" :style="{ top: top + 'px' }" @mouseenter="toggleHoverMenu(target)" @mouseleave="toggleHoverMenu(target)">
    <ul v-for="data in menuList" :key="data.name">
      <li :class="{'hover-menu__disabled': data.disabled}" @click="routerPush(data)">
        {{ data.name }}
        <div
          v-if="data.unreadCount !== undefined && data.unreadCount > 0"
          class="l-menu__badge"
          v-text="data.unreadCount > 999 ? '999+' : data.unreadCount"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'HoverMenu',
  props: {
    target: {
      type: String,
      required: true
    },
    menuList: {
      type: Array, // [{ name: String, disabled: Bool }]
      required: true,
    },
    top: {
      type: Number,
      required: true
    },
  },
  methods: {
    ...mapActions({
      toggleHoverMenu: 'hoverMenu/toggleHoverMenu'
    }),
    routerPush(value) {
      if(value.disabled) return
      this.$router.push(value.routerLocationObj)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';
@import '../../../stylesheets/biz_spa/foundation/_mixin.scss';

.hover-menu {
  &__content {
    display: none;
    @include mq(lg) {
      z-index: 2;
      width: 248px;
      background: #3A3B3F;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.05);
      border-radius: 0 4px 4px 0;
      position: absolute;
      left: 95%;
      font-size: 12px;
      line-height: 12px;
      font-weight: bold;
      display: block;
      color: #FFFFFF;
      li {
        position: relative;
        padding: 14px 24px;
        &:not(.hover-menu__disabled):hover {
          background: linear-gradient(0deg, #494A4D, #494A4D);
          cursor: pointer;
        }
      }
      &::after {
        position: absolute;
        top: 15px;
        right: 248px;
        width: 0;
        height: 0;
        margin: auto;
        border-top: 5px solid transparent;
        border-right: 5px solid #3A3B3F;
        border-bottom: 5px solid transparent;
        content: "";
      }
    }
  }
  &__disabled {
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
